import React from 'react';
import {ControlLabel, FormControl, FormGroup, HelpBlock} from "react-bootstrap";

function FieldGroup({ id, label, help, ...props }) {
    return (
        <FormGroup controlId={id}>
            {label && <ControlLabel>{label}</ControlLabel>}
            <FormControl {...props} />
            {help && <HelpBlock>{help}</HelpBlock>}
        </FormGroup>
    );
}

export default FieldGroup


// WEBPACK FOOTER //
// ./src/components/FieldGroup.js